'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { AsyncActionResponse } from '@pioz/mlm-common';
import { SubmitButton, TextInput } from '@pioz/mlm-skeleton/form-fields';
import { useRouter } from 'next/navigation';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { LogoutButton } from './logout/common-buttons';

const pinZod = (t: { required: string; incorrectPin: string }) =>
  z.string().regex(/^[0-9]{6}$/, t.incorrectPin);

export function TwoFaVerify({
  activateAction,
  t,
  errorsT,
}: {
  activateAction: (data: FormData) => AsyncActionResponse<{ redirect: string }>;
  t: {
    title: string;
    instruction: string;
    pin: string;
    backToLogin: string;
    submit: string;
  };
  errorsT: {
    invalidFormat: string;
    incorrectPin: string;
    required: string;
  };
}) {
  const router = useRouter();
  const registrationkind = process.env.NEXT_PUBLIC_REGISTER_TYPE;
  const pinSchema = useMemo(() => {
    return z.object({
      pin: pinZod(errorsT),
    });
  }, [errorsT]);

  const {
    register,
    setError,
    formState: { isValid, errors },
  } = useForm<{ pin: string }>({
    mode: 'all',
    resolver: zodResolver(pinSchema),
  });

  return (
    <form
      action={async (d) => {
        const response = await activateAction(d);
        if ('error' in response) {
          setError('pin', { message: response.error.message });
          return;
        }

        router.replace(response.success.redirect);
        router.refresh();
      }}
    >
      {!!registrationkind && (
        <input type="hidden" name="registrationkind" value={registrationkind} />
      )}
      <h3 className="text-lg font-bold">{t.title}</h3>
      <p className="py-4">{t.instruction}</p>
      <TextInput autoFocus {...register('pin')} label={t.pin} error={errors.pin} />
      <div className="mt-3 flex flex-col gap-3">
        <SubmitButton className="btn btn-primary" disabled={!isValid}>
          {t.submit}
        </SubmitButton>
        <LogoutButton className="btn">{t.backToLogin}</LogoutButton>
      </div>
    </form>
  );
}
